import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import { Clock } from 'react-feather';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ptLocale from 'date-fns/locale/pt-BR';

import { tempoValida } from './utils/validacoes';

const tema = createMuiTheme({
  typography: {
    fontFamily: 'CircularStd-Book'
  },
  palette: {
    primary: {
      main: '#20174A'
    }
  }
});

const styles = () => ({
  notchedOutline: {},
  focused: {
    '& $notchedOutline': {
      borderColor: '#e040fb !important'
    }
  },
  floatingLabelFocusStyle: {
    color: '#9b2caf !important'
  }
});

export const SelecaoHora = props => {
  const {
    proriedadesPersonalizadas,
    mensagemHoraInvalida,
    KeyboardButtonProps,
    campoRequerido,
    desativarCampo,
    diaReferencia,
    inputVariant,
    cancelLabel,
    etiqueta,
    onChange,
    variant,
    estilos,
    autoOk,
    valor,
    ampm,
    erro,
    id
  } = props;

  const classes = useStyles();
  const [focusOut, setStateFocusOut] = useState(false);
  const [erroCamportamento, setErroCamportamento] = useState(false);

  useEffect(() => {
    const erroPorCampoObrigatorio = campoRequerido && focusOut && !valor;
    const erroPorHoraInvalida = isNaN(valor);
    setErroCamportamento(erroPorCampoObrigatorio || (valor && erroPorHoraInvalida));
  }, [campoRequerido, focusOut, valor]);

  const propriedadesEntrada = {
    variant: 'outlined',
    error: (valor && !tempoValida(valor, diaReferencia)) || erroCamportamento || (!valor && erro),
    classes: { notchedOutline: classes.notchedOutline, focused: classes.focused }
  };

  const propriedadesEntradaEtiqueta = {
    error: (valor && !tempoValida(valor, diaReferencia)) || erroCamportamento || (!valor && erro),
    classes: { focused: classes.floatingLabelFocusStyle }
  };

  const inputAdornmentProps = { onBlur: () => setStateFocusOut(true) };

  return (
    <Grid container>
      <Grid item xs={12} onFocus={() => setStateFocusOut(false)}>
        <ThemeProvider theme={tema}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptLocale}>
            <KeyboardTimePicker
              {...proriedadesPersonalizadas}
              keyboardIcon={<Clock color='#61688B' size={24} />}
              KeyboardButtonProps={KeyboardButtonProps}
              InputLabelProps={propriedadesEntradaEtiqueta}
              InputAdornmentProps={inputAdornmentProps}
              invalidDateMessage={mensagemHoraInvalida}
              onBlur={() => setStateFocusOut(true)}
              InputProps={propriedadesEntrada}
              className={classes.entrada}
              inputVariant={inputVariant}
              required={campoRequerido}
              disabled={desativarCampo}
              cancelLabel={cancelLabel}
              onChange={onChange}
              label={etiqueta}
              variant={variant}
              style={estilos}
              autoOk={autoOk}
              value={valor}
              ampm={ampm}
              id={id}
            />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  entrada: {
    display: 'flex',
    width: '100%'
  },
  notchedOutline: {},
  focused: {
    '& $notchedOutline': {
      borderColor: '#e040fb !important'
    }
  },
  floatingLabelFocusStyle: {
    color: '#9b2caf !important'
  }
});

SelecaoHora.propTypes = {
  proriedadesPersonalizadas: PropTypes.object,
  mensagemHoraInvalida: PropTypes.string,
  KeyboardButtonProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  campoRequerido: PropTypes.bool,
  cancelLabel: PropTypes.string,
  desativarCampo: PropTypes.bool,
  inputVariant: PropTypes.string,
  diaReferencia: PropTypes.any,
  etiqueta: PropTypes.string,
  variant: PropTypes.string,
  estilos: PropTypes.object,
  autoOk: PropTypes.bool,
  valor: PropTypes.any,
  ampm: PropTypes.bool,
  erro: PropTypes.bool
};

SelecaoHora.defaultProps = {
  mensagemHoraInvalida: 'Hora inválida',
  proriedadesPersonalizadas: {},
  inputVariant: 'outlined',
  KeyboardButtonProps: {
    'aria-label': 'change time'
  },
  campoRequerido: false,
  cancelLabel: 'Cancelar',
  desativarCampo: false,
  diaReferencia: null,
  variant: 'inline',
  etiqueta: '',
  autoOk: true,
  estilos: {},
  valor: null,
  ampm: false,
  erro: false
};

export default withStyles(styles)(SelecaoHora);
